/* eslint-disable react/static-property-placement */
import React, { Component } from 'react';
import propTypes from 'prop-types';
import Row from '../Row/Row';
import styles from './Layout.scss';

class Layout extends Component {
  static propTypes = {
    isMobileViewport: propTypes.bool,
    isTrackingPageFontExisted: propTypes.bool,
    layouts: propTypes.arrayOf(propTypes.object),
    uploadedTrackingPageFont: propTypes.shape({
      family: propTypes.string,
    }),
  };

  static defaultProps = {
    isMobileViewport: null,
    isTrackingPageFontExisted: false,
    layouts: {
      layoutType: '',
      rows: [],
    },
    uploadedTrackingPageFont: null,
  };

  getLayoutRows = (layouts, isMobileViewport) => {
    const selectedLayout = isMobileViewport
      ? layouts.find((layout) => layout.layoutType === 'mobile')
      : layouts.find((layout) => layout.layoutType === 'standard');

    return selectedLayout.rows;
  };

  render() {
    const {
      layouts,
      isMobileViewport,
      uploadedTrackingPageFont,
      isTrackingPageFontExisted,
    } = this.props;
    const rows = this.getLayoutRows(layouts, isMobileViewport);
    return (
      <div className={styles.layout}>
        {rows && (rows.map((currentRow) => (
          <Row
            key={currentRow.id}
            row={currentRow}
            isMobileViewport={isMobileViewport}
            isTrackingPageFontExisted={isTrackingPageFontExisted}
            uploadedTrackingPageFont={uploadedTrackingPageFont}
            height={currentRow.rowHeight}
          />
        )))}
      </div>
    );
  }
}

export default Layout;
